import { Badge } from "@/components/ui/badge";
import { menuItemShow } from "@/routes";
import { ChevronRight } from "lucide-react";
import { Link } from "@inertiajs/react";
import Image from "@/components/Image";

const MenuListItem = ({ item }: { item: App.Data.MenuItemData }) => {
    return (
        <Link 
            href={menuItemShow(item.slug)} 
            className="cursor-pointer group" 
            prefetch={true}
            preserveScroll={false}
        >
            <div
                key={item.id}
                className={`flex items-center gap-4 rounded-lg border-2 p-4 px-4 transition-all space-y-2`}
            >
                <div className="w-24 h-26 relative">
                    <Image
                        src={item.image}
                        alt={item.title}
                        placeholder={item.placeholder}
                        className="rounded-md object-cover object-center absolute w-full h-full"
                    />
                </div>
                <div className="min-w-0 flex-1 space-y-3">
                    <div className="space-y-2">
                        <div className="flex items-center gap-0.5 flex-wrap">
                            <h4 className="truncate font-semibold">
                                {item.title}
                            </h4>
                            <Badge
                                variant="secondary"
                                className="shrink-0 text-xs"
                            >
                                {typeof item.category === 'object'
                                    ? item.category.name
                                    : item.category}
                            </Badge>
                        </div>
                        <p className="line-clamp-1 text-sm text-muted-foreground">
                            {item.excerpt}
                        </p>
                        <p className="mt-1 text-sm font-semibold text-primary">
                            {item.price} EGP
                        </p>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-muted-foreground group-hover:text-primary">
                        <span className="transition-colors">
                            Click to View Details
                        </span>
                        <ChevronRight className="size-4 transition-transform group-hover:translate-x-1" />
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default MenuListItem;